import { useaxios } from "../../../utils/useaxios";
export default (category_id) => recaller => setrecaller => initDispatch => clear => settype => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    // initDispatch({ type: 'loadingTrue' });
    useaxios('report/jard.php', { category_id }).then((res) => {
        if (res == "auth_failed") {
            alert('no internet connection');
            return false;
        }
        console.log(res);
        if (res.status == "ok") {
            initDispatch({ type: 'setstok', payload: { stock: res.data, stock_amount: res.total_stock_price } });
            settype('jard');
            // setrecaller(recaller + 1);
        } else {
            // clear();
        }
        // setloading(false);
    });
}